import { AthleteTeamMember } from '@type/db-types';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useCallback } from 'react';
import { upsertAthlete } from '@modules/supabase/users';
import { ACTIVE_SINCE_OPTIONS } from '@components/AddWrestler/AddWrestlerUtils';

interface Props {
    refresh?: () => void;
    user: AthleteTeamMember;
}

export default function ActiveSinceSelector({ refresh, user }: Props) {
    const onChange = useCallback(
        async ({ target: { value: activeSince } }: SelectChangeEvent) => {
            await upsertAthlete({
                id: user.id,
                activeSince,
            });
            refresh?.();
        },
        [refresh, user.id],
    );

    // console.log(`user.activeSince ${user.activeSince}`, {
    //     fullyear: new Date(user.activeSince).getFullYear().toString(),
    //     ACTIVE_SINCE_OPTIONS,
    // });

    return (
        <Select size="small" onChange={onChange} value={user.activeSince}>
            {ACTIVE_SINCE_OPTIONS.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                    <Typography variant="body2">{label}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
